/* eslint-disable import/prefer-default-export */
/**
 * @deprecated
 * 관리대상 트리 노드 서브 타입
 * 해당 객체 참조하는 부분을 @/constants/tree의 treeNodeSubType을 참조하도록 수정 필요.
 * @type {Object}
 */
export const objType = {
  SERVER: 'server',
  NETDEVICE: 'netdevice',
  AP_CONTROLLER: 'ap_controller',
  WIRELESS_AP: 'wireless_ap',
  NETINTERFACE: 'netinterface',
  DBMS: 'dbms',
  SENSOR: 'sensor',
  E2E: 'e2e',
  SERVICE: 'service',
  VIRTUAL: 'virtual',
  APM: 'apm',
};



// WEBPACK FOOTER //
// ./src/constants/obj.js